import styled from "styled-components";
import { devices } from "../styles/Breakpoints";

export const HeaderDiv = styled.div`
  height: 66px;

  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: ${({ theme }) => theme.colors.nrmaBlue};
  z-index: 2;

  img {
    cursor: pointer;
  }

  @media ${devices.tablet} {
    height: 80px;

    justify-content: space-between;

    img {
      margin-left: 40px;
    }
  }
`;

export const FeedbackAndQuoteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    font-size: 16px;
    padding-right: 28px;
    text-decoration: underline;
    cursor: pointer;
  }
  button {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.nrmaSeaFoam};
    width: 147px;
    height: 48px;
    border: 1px solid #000e82;
    box-sizing: border-box;
    border-radius: 2px;
    font-size: 16px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.nrmaBlue};
  }

  @media ${devices.tablet} {
    margin-right: 40px;
  }
`;
